var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#twitter_svg__clip0_7824_5085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.094 11.104l4.262-4.954h-1.01l-3.7 4.301L9.69 6.15H6.281l4.47 6.505-4.47 5.195h1.01l3.908-4.543 3.121 4.543h3.41l-4.636-6.746zm-1.383 1.608l-.453-.648L7.655 6.91h1.551l2.908 4.16.453.647 3.78 5.407h-1.551l-3.085-4.412z",
    fill: "#0D0C1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "twitter_svg__clip0_7824_5085"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgTwitter;